export default interface ResultResponseInterface {
  hasErrors: boolean,
  title: string,
  data: any,
  status: number,
  detail: string,
  instance: string,
  errors: string[],
  messageErroDefault: 'An error occurred while trying to perform this action. Please try again later.'
}

const resultResponseInitialValue: ResultResponseInterface = {
  hasErrors: Boolean(),
  title: String(),
  data: {},
  status: Number(),
  detail: String(),
  instance: String(),
  errors: [],
  messageErroDefault: 'An error occurred while trying to perform this action. Please try again later.'
  };


export { resultResponseInitialValue };
